import React from 'react';
import ProjectCard from './ProjectCard';

const ProjectGrid = ({ projects }) => {
  if (projects.length === 0) {
    return (
      <div className="text-center py-20">
        <p className="text-text-secondary font-body text-lg">
          No projects found in this category yet.
        </p>
        <p className="text-text-light font-body text-sm mt-2">
          Check back soon for new work!
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
      {projects.map((project) => (
        <ProjectCard key={project._id} project={project} />
      ))}
    </div>
  );
};

export default ProjectGrid;
